import { render, staticRenderFns } from "./modeloslaudodescritivo.vue?vue&type=template&id=806480ee"
import script from "./modeloslaudodescritivo.vue?vue&type=script&lang=js"
export * from "./modeloslaudodescritivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports